import React,{useState,useEffect} from 'react'
import { Form, Input, Button, message } from 'antd';
import finish from './../../asset/finish.png'
import {resetPassword,config} from './../../service_psw'
import zxcvbn from 'zxcvbn';
import './step.css'
export default function Step4(props) {
  const { prev, next } = props
  const [passRuleInfo,setpassRuleInfo] = useState()
  const [passLengthInfo,setpassLengthInfo] = useState()
  const [label2,setlabel2] = useState()
  const [label,setlabel] = useState()
  const [psw,setpsw] = useState()
  const [pswlabel,setpswlabel] = useState('')


  useEffect(()=>{
    config().then(res=>{
      setpassRuleInfo(res.data.passRuleInfo)
      setpassLengthInfo(res.data.passLengthInfo)
    })
  },[])
  useEffect(()=>{
    if(psw<4&&psw>0){
      setpswlabel('密码强度低')
    }
    if(psw>=4&&psw<8){
      setpswlabel('密码强度中')
    }
    if(psw>=8){
      setpswlabel('密码强度高')
    }
    if(psw===0){
      setpswlabel('')
    }

  },[psw])

  const onFinish = (values) => {

    if (values.password1 === values.password2) {
      const data = {password:values.password1}
         resetPassword(data).then(res => {
        if (res.resultCode === 0) {
          next()
        } else {
          message.warning(res.errorMsg,[0.5])
        }
      })
    }else{
      message.warning('两次密码不一致',[0.5])
    }
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <>
    <div>请按照密码规则输入密码，密码规则如下:</div>
    <div style={{color:'red'}}>{passRuleInfo} {passLengthInfo}</div>
      <Form
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
        style={{margin:'0'}}
          name="password1"
          rules={[
            {
              required: true,
              message: '请输入密码',
            },
          ]}
        >
          <Input.Password placeholder='请输入密码' onChange={(e)=>{
          setpsw(zxcvbn(e.target.value).guesses_log10)
          }} />
        </Form.Item>
       {psw?<div style={{textAlign:'left'}}>
         <meter min="0" max="12" low="4" high="8" optimum="10" value={psw}></meter>
        <span style={{lineHeight:'40px',marginLeft:'6px',color:'#e97780'}}>{pswlabel}</span>
        </div>:<div style={{height:'26px'}}></div>}
        <Form.Item
          name="password2"
          rules={[
            {
              required: true,
              message: '请输入确认密码',
            },
          ]}

        >
          <Input.Password placeholder='请输入确认密码' />


        </Form.Item>

        <Form.Item
        >
          <Button style={{ height: '36px', margin: 0, marginRight: 15 }} type="" htmlType="submit" onClick={prev}>
            上一步
          </Button>
          <Button style={{ height: '36px', margin: 0 }} type="primary" htmlType="submit">
            下一步
          </Button>
        </Form.Item>
      </Form>
    </>

  )
}